import {
  ReceiveWorkDetailsRequestBody,
  ReceiveWorkDetailsRequestPath,
  ReceiveWorkDetailsResponse,
} from '@eigtech/restoration-types'
import { contextualPost, useMutation } from '@eigtech/ui-shared-api'
import { restorationBasePath } from './constants'
import { useInvalidateJob } from './invalidateJobs'

const recordWorkDetails = ({
  jobId,
  ...payload
}: ReceiveWorkDetailsRequestBody & ReceiveWorkDetailsRequestPath) =>
  contextualPost<ReceiveWorkDetailsResponse, ReceiveWorkDetailsRequestBody>(
    `${restorationBasePath}/job/${jobId}/receive-work-details`,
    payload
  )

export function useRecordWorkDetails() {
  const invalidateJob = useInvalidateJob()

  return useMutation({
    mutationFn: recordWorkDetails,
    onSuccess(__, { jobId }) {
      invalidateJob(jobId)
    },
  })
}
